import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useWorkspaceId } from "@/hooks/use-workspace";

export interface Brand {
  workspace_id: string;
  logo_path: string | null;
  primary_color: string;
  title_font_family: string;
  subtitle_font_family: string;
  custom_font_url: string | null;
  updated_at: string;
}

export function useBrand() {
  const { data: workspaceId } = useWorkspaceId();

  const { data: brand, isLoading } = useQuery({
    queryKey: ["workspace-brand", workspaceId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("workspace_brand")
        .select("*")
        .eq("workspace_id", workspaceId!)
        .maybeSingle();
      if (error) throw error;
      return (data ?? null) as Brand | null;
    },
    enabled: !!workspaceId,
    staleTime: 5 * 60 * 1000,
  });

  const hasBrand = !!brand && (
    !!brand.logo_path ||
    brand.primary_color !== "#2563eb" ||
    brand.title_font_family !== "Space Grotesk" ||
    brand.subtitle_font_family !== "Inter"
  );

  return { brand, hasBrand, loading: isLoading };
}
